
  import { defineComponent } from 'vue';
  import { LegacyFile } from '@/ui/components/inspectionReport/legacyTypes';
  import { saveAs } from 'file-saver';
  import { isPdf } from '@/ui/helpers/systemHelper';
  import { Icon } from '@/ui/components/icon/Icon';

  interface FileItemProps {
    file: LegacyFile;
  }

  export default defineComponent<FileItemProps>({
    components: {
      Icon,
    },
    props: ['file'],
    setup() {
      const makeLink = ({ file_id }: LegacyFile) => `${process.env.VUE_APP_ASSETS_SERVICE_URL}/document/${file_id}`;

      const onSaveClick = (file: LegacyFile) => {
        const link = makeLink(file);
        saveAs(link, file.file_name || 'file');
      };

      return {
        isPdf,
        makeLink,
        onSaveClick,
      };
    },
  });
